import { RuleForm } from "./_RuleForm";

export function RuleEdit() {
  return <RuleForm action="edit" />;
}

export default RuleEdit;
